import app from '../angular_app.es6';

app.directive('stdMarkups', ['$rootScope', '$timeout', 'MarkupTool', 'TranslationService',
  ($rootScope, $timeout, MarkupTool, TranslationService) => {
  return {
    restrict: 'E',
    scope: {
      comments: "=",
      imageUrl: "=",
      selectedConcept: "=",
      size: '='
    },
    template: require('./std_markups_template.html'),

    controller: ['$scope',($scope) => {

      $scope.delayedMarkupOpacityUpdate = null;
      $scope.onMarkupOpacityChange = (p1, value) => {
        $scope.delayedMarkupOpacityUpdate = $timeout( ()=> {
          $rootScope.$broadcast('markupOpacityChange', $scope.state.markupOpacity);
        }, 250);
      };

      $scope.markupOpacityTranslate = (v, arg, kind) => {
        if(kind == "model") return v;
        return !!v ? 'Max' : 'Min';
      };

      $scope.state = {
        loading: false,

        colors: {
          positive: '#3ee85a',
          negative: '#be704c'
        },
        kinds: {
          positive: true,
          negative: true
        },
        markupType: 'area_and_text',
        reactionMode: 'select',
        markupOpacity: 0.2,
        comments: [],
        sliderOptions: {
          floor: 0,
          ceil: 0.7,
          step: 0.0001,
          precision:3,
          hidePointerLabels: false,
          onChange: $scope.onMarkupOpacityChange,
          translate: $scope.markupOpacityTranslate
        },
        selectedRegionId: null
      };
      $scope.selectedSquare = { x: 0, y: 0 };
      $scope.mtMarkups = new MarkupTool([], $scope.state.kinds, $scope.selectedConcept.regions, null, null, $scope.state.markupType);

    }],

    link: ($scope, $element) => {

      $scope.hideAll = false;

      $scope.broadcastReaction = () => {
        $rootScope.$broadcast('expressReactionChanged', $scope.state.kinds);
      };

      $scope.checkHideAll = () => { $scope.hideAll = $scope.mtMarkups.checkAllRespondentsHidden(); };

      $scope.broadcastReaction();

      $scope.$on('show-close-square', (ev, frame) => {
        if (frame){
          $scope.selectedSquare.x = frame.left + frame.width + 4;
          $scope.selectedSquare.y = frame.top - 3;
        }
      });

      $scope.$watch('comments', (newValue, oldValue) => {
        $scope.mtMarkups.setAllComments(newValue);
        $scope.checkHideAll();
        $timeout(() => { $scope.$broadcast('collectionChanged'); });
      });

      $scope.onKindsChange = () => {
        $scope.mtMarkups.setReactions( $scope.state.kinds );
        $scope.broadcastReaction();
        $scope.$broadcast('collectionChanged');
      };

      $scope.onMarkupTypeChange = () => {
        $scope.mtMarkups.setMarkupType($scope.state.markupType);
        $scope.$broadcast('collectionChanged');
      };

      $scope.$on("region-settings-create", (event, data, regions) => {
        $scope.mtMarkups.setRegions($scope.selectedConcept.regions, data.id);
        $scope.$broadcast('collectionChanged');
        $scope.state.reactionMode = 'create';
      });

      $scope.$on("region-settings-updated", (event, data, regions) => {
        $scope.mtMarkups.setRegions(regions, data.id);
        $scope.selectedConcept.regions = regions;
        $scope.state.selectedRegionId = data.id;
        $scope.$broadcast('collectionChanged');
        $scope.state.reactionMode = 'select';
      });


      $scope.$watch('state.reactionMode', (newValue, oldValue) => {
        if(newValue=='create' && oldValue=='select'){
          $scope.mtMarkups.deselectComments();
          $scope.$broadcast('region-create');
        }else if(newValue=='select' && oldValue=='create'){
          $rootScope.$broadcast('region-settings-reset', {concept: $scope.selectedConcept, regionId: $scope.state.selectedRegionId});
        }
      });

      $scope.deselectComments = (event) => {
        if (event){
          event.preventDefault();
          event.stopPropagation();
        }

        $scope.mtMarkups.deselectComments();
        $rootScope.$broadcast('respondentSelected');
      };

      $scope.toggleRespondent = (respondent_id) => {
        let respondent = $scope.mtMarkups.toggleRespondent(respondent_id);
        $rootScope.$broadcast(
          'expressToggleRespondents',
          { allRespondents: [respondent.respondent_id], respondentHidden: respondent.respondent_hidden  }
        );
        $rootScope.$broadcast('respondentHidden');
        $scope.checkHideAll();
      };

      $scope.toggleMarkupVisible = (event, respondent) => {
        event.stopPropagation();
        let markup = $scope.mtMarkups.toggleMarkupVisible(respondent.id);
        $rootScope.$broadcast(
          'expressToggleMarkup',
          { reportCommentId: markup.id, markupVisible: markup.markup_visible  }
        );
        $rootScope.$broadcast('respondentHidden');
      };

      $scope.toggleAllRespondents = (visible) => {
        let respondentIds = $scope.mtMarkups.toggleAllRespondents(visible);
        $rootScope.$broadcast(
          'expressToggleRespondents',
          { allRespondents: respondentIds, respondentHidden: !visible  }
        );
        $rootScope.$broadcast('respondentSelected');
      };

      $scope.toggleHighlight = (respondent, isSelected)=>{
        $scope.mtMarkups.toggleHighlight(respondent, isSelected);
        $rootScope.$broadcast('respondentSelected');
      };

      $scope.moveHighlight = ($event, selected)=>{
        if($event.key == 'ArrowDown' || $event.key == 'ArrowUp' || $event.key == 'Down' || $event.key == 'Up'){
          $scope.mtMarkups.moveHighlight($event.key == 'ArrowUp' || $event.key == 'Up');
          $event.preventDefault();
          $rootScope.$broadcast('respondentSelected');

          $timeout(() => {

            let delta = $('.summary-markup_comment.-selected')[0].offsetTop - $('.summary-markup_comments')[0].offsetTop,
                rowHeight = $('.summary-markup_comment.-selected').outerHeight(),
                windowHeight = $('.summary-markup_comments').height(),
                scrollPos = $('.summary-markup_comments')[0].scrollTop;

            if (delta + rowHeight > scrollPos + windowHeight) {
              $('.summary-markup_comments').animate({scrollTop: delta - windowHeight + 1.5*rowHeight},100);
            }

            if( delta < scrollPos ){
              $('.summary-markup_comments').animate({scrollTop: delta - 0.5*rowHeight},100);
            }

          });

        }
      };

      // Languages and translations

      $scope.useDefaultLanguageField = TranslationService.isDefaultLanguage();

      $scope.answerByLanguage = (item) => {
        return $scope.useDefaultLanguageField ? item.comment : item.translated_text;
      };

      $scope.$on("ChangeScorecardLanguage", () => {
        $scope.useDefaultLanguageField = TranslationService.isDefaultLanguage();
      });


      //--------------------init----------------

      $timeout(function() {
        $scope.$broadcast('rzSliderForceRender')
      }, 100);

    }
  }
}]);


